import { ref } from '@vue/composition-api'
import axios from '@axios'
import { useAuthStore } from '@/pinia/auth'

export function useImportPasien(root) {
  const downloading = ref(false)

  const buildFilename = () => {
    const authStore = useAuthStore()
    const tenantName = (authStore.entity && authStore.entity.name) || ''
    const slug = tenantName.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '')
    const now = new Date()
    const ts = now.getFullYear().toString()
      + String(now.getMonth() + 1).padStart(2, '0')
      + String(now.getDate()).padStart(2, '0')
      + '_'
      + String(now.getHours()).padStart(2, '0')
      + String(now.getMinutes()).padStart(2, '0')
      + String(now.getSeconds()).padStart(2, '0')
    return `template_import_pasien_${slug}_${ts}.xlsx`
  }

  const downloadTemplate = async () => {
    downloading.value = true
    try {
      const response = await axios.get('/pasien/import/template', {
        responseType: 'blob',
      })

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', buildFilename())
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      root.$dekatoast.error('Gagal mengunduh template')
    } finally {
      downloading.value = false
    }
  }

  return { downloading, downloadTemplate }
}
